var _line, _line2, _line3, _line4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgPanel = function SvgPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 0,
    x2: 9.5,
    y2: 16,
    stroke: "#5B5B5B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 5.5,
    x2: 7,
    y2: 5.5,
    stroke: "#5B5B5B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 7.5,
    x2: 7,
    y2: 7.5,
    stroke: "#5B5B5B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9.5,
    x2: 7,
    y2: 9.5,
    stroke: "#5B5B5B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 2.4,
    stroke: "#5B5B5B"
  })));
};
var Memo = /*#__PURE__*/memo(SvgPanel);
export default Memo;